<script lang="ts">
    import { AddEscapeStack } from "@utils/underhood/escape-key"
    import { onMount } from "svelte"
    export let fn: () => void
    export let name: string
    onMount(() => AddEscapeStack({ name, fn }))
</script>
